@if (svgHtml()) {
  <ngx-dynamic-hooks data-source="prismic" [options]="{ sanitize: false }" [content]="svgHtml()"></ngx-dynamic-hooks>
}
